import { Component, Input } from '@angular/core';
import { PopupFieldData } from 'src/app/features/designer-studio/edit-pdf-doc/models/doc.model';

@Component({
  selector: 'app-screen-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent {
  @Input() initOptions: PopupFieldData;
}
